import { SINO_NUM_70_79 } from "../../../../SubjectData/BasicWords/Numbers/SinoNums.js";
import "../../../Deck.css";
import FlashcardInterface from "../../../Flashcard_Interface.js";
import HeaderNav from "../../../../Components/Header/Header_Nav/Header_Nav.js";

export default function SINO_NUM_70_79_DECK() {
  return (
    <>
      <HeaderNav GoBack_to="/NumbersNav" />
      <FlashcardInterface deckData={SINO_NUM_70_79} title="Sino Numbers: 70-79" />
    </>
  );
}
